export default __webpack_public_path__ + "static/devops-casestudy-3-3afc77d19b072c6caf0783e7369f8ce3.png";